export default __webpack_public_path__ + "static/media/delivery_person_orange.952674bf.svg";